import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { PortalDashboardCTAPanelModel } from './portal-dashboard-cta.model';

@Injectable({
  providedIn: 'root'
})
export class PortalDashboardCTAService extends PortalBaseService {
  public getCTAPanels(): Promise<PortalDashboardCTAPanelModel[]> {
    return lastValueFrom(this.get<PortalDashboardCTAPanelModel[]>('portal/dashboard-cta'));
  }
  public getApplicationLink(formId: string): Promise<{ link: string }> {
    return lastValueFrom(this.post(`portal/dashboard-cta/form/${formId}/request`, {}));
  }
}
